var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.638 8.438c0-.432.35-.782.781-.782h.781v-.781c0-.431.35-.781.782-.781.431 0 .78.35.78.781v.781h.782c.432 0 .781.35.781.782 0 .431-.35.78-.78.78h-.782V10c0 .431-.35.781-.781.781-.432 0-.782-.35-.782-.781v-.781h-.78c-.432 0-.782-.35-.782-.781zM19.975 4.1l-2.324 9.063c-.088.345-.4.587-.756.587H3.905c-.43 0-.78-.35-.78-.781V1.563H.78C.35 1.563 0 1.212 0 .78 0 .35.35 0 .781 0h3.125c.431 0 .781.35.781.781v2.344h14.531c.51 0 .884.482.757.975zm-1.763.588H4.687v7.5h11.601l1.924-7.5zm-10.4 12.968C7.812 18.95 6.761 20 5.468 20c-1.292 0-2.343-1.051-2.343-2.344 0-1.292 1.051-2.343 2.343-2.343 1.293 0 2.344 1.05 2.344 2.343zm-1.562 0c0-.43-.35-.781-.782-.781-.43 0-.78.35-.78.781 0 .431.35.782.78.782.431 0 .782-.351.782-.782zm9.886 0c0 1.293-1.051 2.344-2.344 2.344-1.292 0-2.343-1.051-2.343-2.344 0-1.292 1.05-2.343 2.343-2.343s2.344 1.05 2.344 2.343zm-1.562 0c0-.43-.351-.781-.782-.781-.43 0-.781.35-.781.781 0 .431.35.782.781.782.431 0 .782-.351.782-.782z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add-to-cart.4820fe9f89f8aaa4054e01b96af2d353.svg";
export { ForwardRef as ReactComponent };